import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { AdsDeleteApi, AdsGETApi, AdsGETApiAuth, AdsPOSTApi, AdsPUTApi, UserMe } from "../../../Constant/api";
import { slugs } from "../../../Constant/slugs";
import { CustomButton } from "../../CustomButtom";
const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.meta.user_id,
    sortable: true,
    reorder: true,
    width: "100px"
  },
  {
    id: 31,
    name: "Title",
    selector: (row) => row.title.rendered,
    sortable: true,
    reorder: true,
    width: "150px"

  },
  {
    id: 312,
    name: "Phone",
    selector: (row) => row.meta.user_phone_number,
    sortable: true,
    reorder: true,
    width: "150px"
  },
  {
    id: 32,
    name: "username",
    selector: (row) => row.meta.user_name,
    sortable: true,
    reorder: true,
    width: "250px"
  },
  {
    id: 3222,
    name: "role",
    selector: (row) => row.meta.nfdin,
    sortable: true,
    reorder: true,
    width: "150px"
  },
  //  {
  //   id: 3444,
  //   name: "course",
  //   selector: (row) => row.meta.verified_course_list,
  //   sortable: true,
  //   reorder: true
  // },
  {
    id: 3,
    name: "View",
    cell: (row) => <Link to={`${slugs.student_details}${row.slug}`}>View</Link>,
    width: "150px"
  }
];

export default function AllNFDINStudents() {
  const [Projects1, setProjects1] = React.useState([])
  const [Projects2, setProjects2] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [SubscriberTotal, setSubscriberTotal] = React.useState(0)
  const [StudentTotal, setStudentTotal] = React.useState(0)
  const [UnverifiedTotal, setVerifiedTotal] = React.useState(0)
  const [AdminTotal, setAdminTotal] = React.useState(0)
  const [AllTotal, setAllTotal] = React.useState(0)
  const [serachName, setSearchName] = React.useState("")
  const [serachEmail, setSearchEmail] = React.useState("")
  const [serachPhone, setSearchPhone] = React.useState("")
  const [toStudentModel, setToStudentModal] = React.useState(false)
  const [ChangeToStudentModal, setChangeToStudentModal] = React.useState(false)
  const [ChangeToStudentBatchModal, setChangeToStudentBatchModal] = React.useState(false)
  const [ImportData, setImportData] = React.useState([])
  const [file, setFile] = React.useState();
  const fileReader = new FileReader();
  const fileRefSingle = React.createRef();
  const [batchID, setBatchID] = React.useState("")
  const [batchPrice, setBatchPrice] = React.useState("")
  const [batchUpto, setBatchUpto] = React.useState("")
  const [batchName, setBatchName] = React.useState("")
  const [batchList, setBatchList] = React.useState([])
  const [batchSelectListModal, setBatchSelectListModal] = React.useState(false)
  const [batchSelectList, setBatchSelectList] = React.useState([])
  const [batchCacheList, setBatchCacheList] = React.useState([])
  const [forDelete, setForDelete] = React.useState([])

  const handleOnChange = (e) => {
    // setFile(e.target.files[0]);
    e.preventDefault();
    const file = e.target.files[0]
    if (file) {
      fileReader.onload = function (event) {
        const csvOutput = event.target.result;
        const jsonData = convertCSVToJson(csvOutput);

        console.log(jsonData)
        var newData = []
        for (let i = 0; i < jsonData.length; i++) {
          const jsonDatai = jsonData[i]
          var chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          var passwordLength = 12;
          var password = "";
          for (let l = 0; l <= passwordLength; l++) {
            var randomNumber = Math.floor(Math.random() * chars.length);
            password += chars.substring(randomNumber, randomNumber + 1);
          }
          newData.push({
            "title": { rendered: jsonDatai["Fullname"], },
            "status": "publish",
            "meta": {
              "user_role": "student",
              "user_name": jsonDatai["Username"],
              "user_password": jsonDatai["Phonenumber"] == "" ? password : jsonDatai["Phonenumber"],
              "user_phone_number": jsonDatai["Phonenumber"],
              "user_email": `${jsonDatai["Phonenumber"]}@loksewanetwork.com`,
              // "nfdin": "tsc",
              // "nfdin": "officer",
              "nfdin": "nasu",
              "verified_course_list": `[{"course_id":37672,"name":"शिक्षक सेवा तयारी कक्षा -2083"}]`,
              // "verified_course_list": `[{"course_id":26121,"name":"NFDIN : नायब सुब्बा तयारी कक्षा"}]`,
              // "verified_course_list": `[{"course_id":4359,"name":"IQ For All"},{"course_id":26120,"name":"NFDIN : शाखा अधिकृत तयारी कक्षा"}]`,
              "user_address": `${jsonDatai["address"]}`
            }
          })
        }
        setImportData(newData)
      };
      fileReader.readAsText(file);
    };
  }
  const convertCSVToJson = (csvData) => {
    const lines = csvData.split("\n");
    console.log(lines)
    const headers = lines[0].replace("\r", "").split(",");
    const result = [];
    // console.log(headers, lines[0])
    for (let i = 1; i < lines.length; i++) {
      var obj = {};
      const currentLine = lines[i].replace("\r", "").split(",");
      // console.log(currentLine)
      for (let j = 0; j < headers.length; j++) {
        // obj[headers[j].trim()] = currentLine[j].trim();
        console.log(headers[j])
        var key = headers[j]
        obj = {
          ...obj,
          [key]: currentLine[j]
        }
      }
      // console.log(obj)

      result.push(obj);
    }
    // setImportData(result)
    return result;
  };
  const GetTotal = (Role, setDataLength, all) => {
    setReload(true)
    setProjects1([])
    const allT = !all ? {
      "filter[meta_query][1][key]": "user_role",
      "filter[meta_query][1][value][0]": `${Role}`,
      "filter[meta_query][1][compare]": "=",
      per_page: 1
    } : { per_page: 1 }
    AdsGETApiAuth(allT, slugs.db_slug_user_data)
      .then((res) => {
        setDataLength(res.headers["x-wp-total"])
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, slugs.db_slug_user_data)
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  const GetAll = () => {
    GetAllProjects({
      per_page: 4999,
      "filter[meta_query][1][key]": "nfdin",
      "filter[meta_query][1][value][0]": `nasu`,
      "filter[meta_query][1][compare]": "==",
      "filter[meta_query][relation]": "OR",
      "filter[meta_query][2][key]": "nfdin",
      "filter[meta_query][2][value][0]": `officer`,
      "filter[meta_query][2][compare]": "==",

    })
    BatchList()
  }

  useEffect(() => {
    GetAll()
  }, [])
  const BatchList = () => {
    AdsGETApiAuth(
      { per_page: 100, _fields: "id,title,meta.batch_status,meta.batch_price_list,meta.category_name" },
      slugs.db_slug_batch
    )
      .then((res) => {
        setBatchList(res.data)
      })
      .catch(e => {
        console.log(e)
      })
  }
  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Students</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Students
        </div>
      </div>
      <a href={slugs.new_nfdin_student}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
          onClick={() => {

          }}
        >Add New Student</div>
      </a>
      <div style={{ display: "inline-block", margin: "0px 5px" }}
        onClick={() => {
          setImportData([])
          setToStudentModal(true)
        }}
      >
        Add Multiple
      </div>
      <div style={{ display: "inline-block", margin: "0px 5px" }}
        onClick={() => {
          console.log(Projects2.length)
          for (let i = 0; i < Projects2.length; i++) {
            // console.log(Projects1[i].meta.verified_course_list)
            // console.log(Projects1[i].id)
            setTimeout(() => {
              AdsPUTApi(
                {
                  meta: {
                    "verified_course_list": `[{"course_id":4359,"name":"IQ For All"},{"course_id":26120,"name":"NFDIN : शाखा अधिकृत तयारी कक्षा"}]`,
                  }
                }, slugs.db_slug_user_data, Projects2[i].id)
                .then((res) => {
                  if (i == Projects2.length - 1) {
                    GetAll()
                  }
                })
                .catch((err) => {
                  console.log(err)
                })
            }, i * 300)
          }

        }}
      >
        Update Users
      </div>
      <div className="row">
        <div className="col-md-6">
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setProjects1(CustomersList)
              }}
            >
              All ({CustomersList.length}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setProjects1(CustomersList.filter(a => a.meta.nfdin == "nasu"))
              }}
            >
              Nasu ({CustomersList.filter(a => a.meta.nfdin == "nasu").length}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setProjects1(CustomersList.filter(a => a.meta.nfdin == "officer"))
              }}
            >
              Officer ({CustomersList.filter(a => a.meta.nfdin == "officer").length}) |
            </div>
          </div>
        </div>
        <div className="col-md-6 row">
          <div className="col-4" />
          <input className="col-2" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachName} placeholder="Name"
            onChange={(event) => {
              setSearchName(event.target.value)
              setProjects1(CustomersList.filter(a => a.meta.user_name.includes(event.target.value)))
            }}
          />
          <input className="col-3" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachEmail} placeholder="Email"
            onChange={(event) => {
              setSearchEmail(event.target.value)
              setProjects1(CustomersList.filter(a => a.meta.user_email.includes(event.target.value)))
            }}
          />
          <input className="col-2" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachPhone} placeholder="Phone"
            onChange={(event) => {
              setSearchPhone(event.target.value)
              setProjects1(CustomersList.filter(a => a.meta.user_phone_number.includes(event.target.value)))
            }}
          />
        </div>
      </div>

      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          paginationPerPage={100}
          paginationRowsPerPageOptions={[10, 50, 100, 1000]}
          columns={columns}
          data={Projects1}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          onSelectedRowsChange={(r) => {
            console.log("asdasd", r)
            setProjects2(r.selectedRows)
          }}
          pagination
          selectableRows
        />
      </div>
      {toStudentModel &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-2 col-1"></div>
            <div className="col-md-8 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setToStudentModal(false)
                    setImportData([])

                  }}
                >X</div>
                <div style={{ display: "none" }} >
                  <input ref={fileRefSingle}
                    type={"file"}
                    id={"csvFileInput"}
                    accept={".csv"}
                    onChange={handleOnChange}
                  />
                </div>
                <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
                  onClick={() => {
                    fileRefSingle.current.click()
                  }}
                >Import CSV</div>

                <div style={{ maxHeight: "50vh", overflow: "scroll", backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <table style={{ maxHeight: "50vh" }}>
                    <thead>
                      <tr>
                        <td>SN</td>
                        <td>User Name</td>
                        <td>Name</td>
                        {/* <td>Email</td> */}
                        {/* <td>Password</td> */}
                        <td>Phone Number</td>
                        {/* <td>Role</td> */}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.values(ImportData).map((item, index) => (
                        <tr key={index}>
                          <TableRow row={item} index={index}
                            ImportData={ImportData} setImportData={setImportData} />
                        </tr>
                      ))}
                      {/* <TableRow row={item} index={index} /> */}

                      <tr>
                        <td colSpan={6} className="center" style={{ cursor: "pointer" }}
                          onClick={() => {
                            setImportData(
                              {
                                ...ImportData,
                                [Object.values(ImportData).length]: {
                                  "title": { rendered: "", },
                                  "meta": {
                                    "user_role": "",
                                    "user_name": "",
                                    "user_password": "",
                                    "user_phone_number": "",
                                    "user_email": "",
                                  }
                                }
                              }
                            )
                          }}
                        >
                          Add New
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="row center">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setToStudentModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div className="col-3 center">
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        const Projects = Object.values(ImportData)
                        for (let i = 0; i < Projects.length; i++) {
                          setTimeout(() => {
                            const item = {
                              title: Projects[i].title.rendered,
                              "status": "publish",
                              meta: Projects[i].meta,
                            }
                            var email = item.meta.user_email
                            const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
                            function validateEmail(email) {
                              return emailRegex.test(email);
                            }
                            var isValidEmail = validateEmail(item.meta.user_email);
                            var chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                            var passwordLength = 12;
                            var password = "";
                            for (let l = 0; l <= passwordLength; l++) {
                              var randomNumber = Math.floor(Math.random() * chars.length);
                              password += chars.substring(randomNumber, randomNumber + 1);
                            }
                            var passwordConfirmed;
                            if (item.meta.user_password != "") {
                              passwordConfirmed = item.meta.user_password
                            }
                            else
                              isValidEmail = false

                            if (isValidEmail) {
                              const dataWithPassword = {
                                "username": item.meta.user_name,
                                "email": item.meta.user_email,
                                "password": passwordConfirmed,
                                "roles": item.meta.user_role
                              }
                              // console.log(item)
                              setReload(true)
                              AdsPOSTApi(dataWithPassword, "users")
                                .then(res => {
                                  const item = {
                                    title: Projects[i].title.rendered,
                                    "status": "publish",
                                    meta: {
                                      ...Projects[i].meta,
                                      "user_id": `${res.data.id}`
                                    }
                                  }
                                  // console.log(item)
                                  AdsPOSTApi(item, slugs.db_slug_user_data)
                                    .then((res) => {
                                      // console.log(item)
                                    }).catch(err => {
                                      console.log(err)
                                    })

                                })
                                .catch(err => {
                                  if (err.code == "ERR_BAD_RESPONSE") {
                                    AdsGETApiAuth({
                                      "filter[meta_query][1][key]": "user_name",
                                      "filter[meta_query][1][value][0]": `${item.meta.user_name}`,
                                      "filter[meta_query][1][compare]": "=",
                                    }, slugs.db_slug_user_data)
                                      .then(res2 => {
                                        if (res2.data.length == 0) {
                                          console.log(res2.data)

                                          UserMe(window.btoa(`${item.meta.user_name}:${item.meta.user_password}`))
                                            .then((res3) => {
                                              const item = {
                                                title: Projects[i].title.rendered,
                                                "status": "publish",
                                                meta: {
                                                  ...Projects[i].meta,
                                                  "user_id": `${res3.data.id}`
                                                }
                                              }
                                              AdsPOSTApi(item, slugs.db_slug_user_data)
                                                .then((res) => {
                                                  // console.log(item)
                                                }).catch(err => {
                                                  console.log(err)
                                                })
                                            })
                                          console.log("Needed")
                                        }
                                        else
                                          AdsPUTApi({
                                            meta: {
                                              "nfdin": "nasu",
                                              // "nfdin": "officer",
                                              // "verified_course_list": `[{"course_id":26121,"name":"NFDIN : नायब सुब्बा तयारी कक्षा"},{"course_id":4359,"name":"IQ For All"}]`,
                                              // "verified_course_list": `[{"course_id":4359,"name":"IQ For All"},{"course_id":26120,"name":"NFDIN : शाखा अधिकृत तयारी कक्षा"}]`,
                                              // "verified_course_list": `[{"course_id":26121,"name":"NFDIN : नायब सुब्बा तयारी कक्षा"},{"course_id":4359,"name":"IQ For All"}]`,
                                            }
                                          }, slugs.db_slug_user_data, res2.data[0].id)
                                      })

                                  }

                                })
                                .finally(() => {
                                  if (i == Projects.length - 1) {
                                    alert(`${Projects.length} students added`)
                                    setReload(false)
                                    GetAll()
                                    setToStudentModal(false)
                                  }
                                })
                            }
                            else
                              if (i == Projects.length - 1) {
                                alert(`${Projects.length} students added`)
                                setReload(false)
                                GetAll()
                                setToStudentModal(false)
                              }
                          }, i * 1000)
                        }
                      }}
                    >
                      Add All Studenta
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {Reload &&
            <div className="modal" style={{ padding: "50vw" }}>
              <div className="dot-pulse"></div>
            </div>
          }
        </section>
      }
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }

      {ChangeToStudentBatchModal &&
        <>
          <section className="modal" >
            <div className="row" style={{ overflow: "hidden" }}>
              <div className="col-md-3 col-1"></div>
              <div className="col-md-6 col-10  shadow bg-white">
                <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                  <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                    onClick={() => {
                      setChangeToStudentBatchModal(false)
                    }}
                  >X</div>
                  Do you really want to Assign Class of all selected users?<br />
                  {batchID}
                  <div className="row">
                    <div className="col-3 center " >
                      <div className="sign-in-button-4" style={{ width: "80%" }}
                        onClick={() => {
                          setChangeToStudentBatchModal(false)
                        }}
                      >
                        Cancel
                      </div>
                    </div>
                    <div className="col-3 center">
                      <div className="sign-in-button-4" style={{ width: "80%" }}
                        onClick={() => {
                          setChangeToStudentBatchModal(false)
                          for (let i = 0; i < Projects2.length; i++) {
                            setReload(true)
                            AdsPUTApi({
                              meta: {
                                "batch_id": "",
                                "batch_name": "",
                              }
                            }, slugs.db_slug_user_data, Projects2[i].id)
                              .then((res) => {
                                if (i == Projects2.length - 1) {
                                  GetAll()
                                }
                              })
                          }
                        }}
                      >
                        Reset Class
                      </div>
                    </div>
                    <div className="col-3 center">
                      <div className="sign-in-button-4" style={{ width: "80%" }}
                        onClick={() => {
                          setChangeToStudentBatchModal(false)
                          for (let i = 0; i < Projects2.length; i++) {
                            setReload(true)
                            AdsPUTApi({
                              meta: {

                              }
                            }, slugs.db_slug_user_data, Projects2[i].id)
                              .then((res) => {
                                if (i == Projects2.length - 1) {
                                  GetAll()
                                }
                              })
                          }
                        }}
                      >
                        Set Selected Class
                      </div>
                    </div>
                  </div>
                  <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                    <table>
                      <tbody>
                        {batchList.map((item, index) => (
                          <tr className="row bg-white shadow" key={index}
                            style={{ cursor: "pointer", border: "1px solid #999" }}
                            onClick={() => {
                              if (batchID != item.id) {
                                setBatchID(`${item.id}`)
                                setBatchName(item.title.rendered)
                              }
                              else {
                                setBatchID(``)
                                setBatchName("")
                              }
                            }}
                          >
                            <td className="col-1">
                              {batchID != item.id ?
                                <i className="fa fa-square-o" />
                                :
                                <i className="fa fa-check-square-o" />
                              }
                            </td>
                            <td className="col-2" >
                              {item.id}
                            </td>
                            <td className="col-3">
                              {item.title.rendered}
                            </td>
                            <td className="col-3">
                              {item.meta.batch_start_date}
                            </td>
                            <td className="col-3">
                              {item.meta.batch_end_date}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <table>
            <tbody>
              {batchList.map((item, index) => (
                <tr className="row bg-white shadow" key={index}
                  style={{ cursor: "pointer", border: "1px solid #999" }}
                  onClick={() => {
                  }}
                >
                  <td className="col-1">
                    {batchID !== item.id ?
                      <i className="fa fa-square-o" />
                      :
                      <i className="fa fa-check-square-o" />
                    }
                  </td>
                  <td className="col-2" >
                    {item.id}
                  </td>
                  <td className="col-3">
                    {item.title.rendered}
                  </td>
                  <td className="col-3">
                    {item.meta.batch_start_date}
                  </td>
                  <td className="col-3">
                    {item.meta.batch_end_date}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      }
    </div>
  )
}


const TableRow = ({ row, index, ImportData, setImportData }) => {
  const [name, setName] = React.useState(row.title.rendered)
  const [LoginName, setLoginName] = React.useState(row.meta.user_name)
  const [email, setEmail] = React.useState(row.meta.user_email)
  const [PassWord, setPassword] = React.useState(row.meta.user_password)
  const [PhoneNumber, setPhoneNumber] = React.useState(row.meta.user_phone_number)
  const [Role, setRole] = React.useState(row.meta.user_role)
  return (
    <>
      <td>{index + 1}</td>
      <td>
        <input className="input-common-2"
          value={LoginName} placeholder="User Name"
          onChange={(event) => {
            setName(event.target.value)
            // console.log(JSON.stringify(ImportData[index]))

            const ImportData2 = {
              ...ImportData,
              [index]: {
                title: { rendered: event.target.value },
                meta: { ...ImportData[index].meta, user_name: event.target.value }
              }
            }
            setImportData(ImportData2)
          }}
        />
      </td>
      <td>
        <input className="input-common-2"
          value={name} placeholder="User Name"
          onChange={(event) => {
            setName(event.target.value)
            console.log(JSON.stringify(ImportData[index]))

            const ImportData2 = {
              ...ImportData,
              [index]: {
                title: { rendered: event.target.value },
                meta: { ...ImportData[index].meta, user_name: event.target.value }
              }
            }
            setImportData(ImportData2)
          }}
        />
      </td>
      {/* <td>
        <input className="input-common-2"
          value={email} placeholder="Email"
          onChange={(event) => {
            setEmail(event.target.value)
            const ImportData2 = {
              ...ImportData,
              [index]: {
                title: ImportData[index].title,
                meta: { ...ImportData[index].meta, user_email: event.target.value }
              }
            }
            setImportData(ImportData2)
          }}
        />
      </td> */}

      {/* <td>
        <div style={{ display: "inline" }}>
          <div style={{ display: "inline-block" }}> */}

      {/* <input className="input-common-2 col-6"
              value={PassWord} placeholder="Password"
              onChange={(event) => {
                setPassword(event.target.value)
                const ImportData2 = {
                  ...ImportData,
                  [index]: {
                    title: ImportData[index].title,
                    meta: { ...ImportData[index].meta, user_password: event.target.value }
                  }
                }
                setImportData(ImportData2)
              }}
            /> */}
      {/* <div style={{ display: "inline-block", cursor: "pointer" }}
              onClick={() => {
                var chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                var passwordLength = 12;
                var password = "";
                for (let l = 0; l <= passwordLength; l++) {
                  var randomNumber = Math.floor(Math.random() * chars.length);
                  password += chars.substring(randomNumber, randomNumber + 1);
                }
                setPassword(password)
                const ImportData2 = {
                  ...ImportData,
                  [index]: {
                    title: ImportData[index].title,
                    meta: { ...ImportData[index].meta, user_password: password }
                  }
                }
                setImportData(ImportData2)
              }}
            >
              &nbsp;Generate
            </div> */}
      {/* </div>
        </div>
      </td> */}
      <td>
        <input className="input-common-2"
          value={PhoneNumber} placeholder="Phone Number"
          onChange={(event) => {
            setPhoneNumber(event.target.value)
            const ImportData2 = {
              ...ImportData,
              [index]: {
                title: ImportData[index].title,
                meta: { ...ImportData[index].meta, user_phone_number: event.target.value }
              }
            }
            setImportData(ImportData2)
          }}
        />
      </td>
      <td>
        {/* <CustomButton setData={setRole} Data={Role} DataValue={"subscriber"}
          index={index} ImportData={ImportData} setImportData={setImportData} /> */}
        <CustomButton setData={setRole} Data={Role} DataValue={"student"}
          index={index} ImportData={ImportData} setImportData={setImportData} />
      </td>
      {/* <td onClick={() => {
      }}>
        Done
      </td> */}
    </>
  )
}